import React, { FC } from 'react';

import { Popconfirm, Button, Tooltip } from 'antd';
import { BaseButtonProps } from 'antd/lib/button/button';
import ConfirmButton from './ConfirmButton';
import { PlusCircleOutlined, EditOutlined, DeleteOutlined, HomeOutlined, EyeOutlined, CopyOutlined } from '@ant-design/icons';

interface CommonButtonProps extends BaseButtonProps {
  title?: string;
  tooltip?: any;
  onClick?: (any) => any;
  onConfirm?: (any) => any;
  confirmtext?: string;
  onCancel?: (any) => any;
  icon?: any;
  color?: string;
  isConfirm?: boolean;
  disabled?: boolean;
  onlyIcon?: boolean;
}

const CommonButton: FC<CommonButtonProps> = (props) => {
  let icon = props.icon || null;

  const { confirmtext, onConfirm, isConfirm } = props;
  if (typeof icon === 'string') icon = Icons?.[icon] || <PlusCircleOutlined />;
  if (isConfirm) {
    if (props.tooltip) {
      return (
        <Tooltip title={props.tooltip}>
          <ConfirmButton {...props} icon={icon} type={props.type} title={props.title}>
            {!props.title && props.children}
          </ConfirmButton>
        </Tooltip>
      );
    }
    return (
      <ConfirmButton {...props} icon={icon} type={props.type} title={props.title}>
        {!props.title && props.children}
      </ConfirmButton>
    );
  }
  if (onConfirm) {
    return (
      <Popconfirm
        title={confirmtext}
        onConfirm={onConfirm}
        onCancel={props.onCancel}
        okText="Si"
        cancelText="No"
      >
        <Button {...props} icon={icon} type={props.type} title={props.title}>
          {!props.title && props.children}
        </Button>
      </Popconfirm>
    );
  }
  if (props.tooltip) {
    return (
      <Tooltip title={props.tooltip}>
        <Button
          {...props}
          icon={icon}
          type={props.type}
          onClick={props.onClick}
          title={props.title}
        >
          {!props.title && props.children}
        </Button>
      </Tooltip>
    );
  }
  return (
    <Button {...props} icon={icon} type={props.type} onClick={props.onClick} title={props.title}>
      {!props.title && props.children}
    </Button>
  );
};

CommonButton.defaultProps = {
  confirmtext: "Confermare l'azione?",
  type: 'default',
  title: '',
};

const Icons = {
  edit: <EditOutlined />,
  eye: <EyeOutlined />,
  'plus-circle': <PlusCircleOutlined />,
  add: <PlusCircleOutlined />,
  remove: <DeleteOutlined />,
  delete: <DeleteOutlined />,
  home: <HomeOutlined />,
  clone: <CopyOutlined />,
};
export default CommonButton;
